module.exports = __webpack_public_path__ + "static/media/intro.8e1b839f.mp3";